import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import BespokeExperiences from "./sections/BespokeExperiences";
import WhereWeBloom from "./sections/WhereWeBloom";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <BespokeExperiences />
      <WhereWeBloom />
      <Footer />
    </div>;
}